import { configsInfo } from '@/utils/allConfigs'
import { theInitialTheme } from './setInitialTheme'
const projectVersion = require('../../package.json').version

export const initialTheme = () => {
  return {
    ...theInitialTheme()
  }
}

export const isHexColor = (colorCode) => {
  return /^#[0-9A-F]{6}$/i.test(colorCode) || /^#([0-9A-F]{3}){1,2}$/i.test(colorCode)
}

export const buildUrl = (data, checknull = true) => {
  const ret = []
  for (const d in data) {
    if (checknull) {
      if (data[d] !== null && data[d] !== '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
      }
    } else {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
    }
  }
  return ret.join('&')
}

export const formatOptions = (config) => {
  try {
    const theme = config.theme
    delete config.theme
    for (const element in theme) {
      for (const prop in theme[element]) {
        // We allow properties to be set for each element. Button can have color, background-color, border-radius. Create a name-value pair for each one and prefix it with theme.
        // E.g button_color = '#ffffff'
        config[`theme_${element}_${prop}`] = theme[element][prop]
      }
    }
  } catch (error) {}

  try {
    delete config.containerMinHeight // only need this for the iframe-element
    const attributes = config.attributes
    delete config.attributes
    for (const attribute in attributes) {
      config[`attributes.${attribute}`] = attributes[attribute]
    }
    for (const userAttribute in config.user) {
      config[`user.${userAttribute}`] = config.user[userAttribute]
    }
  } catch (error) {}

  return config
}

/**
 * @param { Function } // constructor function to build initialtheme configs
 * @param { object } // object containing current theme options
 * @returns { object } // with the diff of user configs and the default configs as we only need the diff.
 */
export const getCleanThemes = (getInitialTheme, current) => {
  const initialTheme = getInitialTheme()
  const theme = current
  const newTheme = {}
  for (const prop in theme) {
    for (const innerProp in theme[prop]) {
      if (initialTheme[prop][innerProp] !== theme[prop][innerProp]) {
        if (prop in newTheme) {
          newTheme[prop] = { ...newTheme[prop] }
        } else {
          newTheme[prop] = {}
        }
        newTheme[prop][innerProp] = theme[prop][innerProp]
      }
    }
  }
  return newTheme
}

// We only need the diff from the default options
export const getCleanConfigs = (initialConfigs, current) => {
  const getInitial = initialConfigs('notStoredData')
  const cleanObj = {}
  for (const prop in current) {
    if (JSON.stringify(current[prop]) !== JSON.stringify(getInitial[prop])) {
      cleanObj[prop] = current[prop]
    }
  }
  return cleanObj
}

export const getParams = (url) => {
  const params = {}
  const parser = document.createElement('a')
  parser.href = url
  const query = parser.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    params[pair[0]] = decodeURIComponent(pair[1])
  }
  return params
}

export const iframeUrl = () => {
  const iframeUrl = document.querySelector('#cashierIframe')
  try {
    const getContentWindow = iframeUrl.contentWindow
    return getContentWindow.location.href
  } catch (err) {
    console.log('Failed getting iframeUrl')
    console.log(err)
    return null
  }
}

export const getVersionFromUrl = async (getIframeUrl) => {
  try {
    const url = iframeUrl()
    // const url = 'https://test-api.paymentiq.io/paymentiq/cashier/?merchantId=1000&userId=123&sessionId=123&environment=test&method=deposit&containerHeight=85vh&containerWidth=1655px&accountDelete=true&additionalCashierText=true&allowCancelPendingWithdrawal=false&allowUserToDisableCancelWithdrawals=false&alwaysShowSubmitBtn=false&amountFirst=false&autoOpenFirstPaymentMethod=true&autoProcess=false&country=swe&disableBtnAtZero=true&displayLogoOrName=both&errorMsgTxRefId=false&feeAmount=&globalSubmit=false&history=false&isMobile=false&layout=vertical&listRadio=true&listType=list&locale=en&logoFullWidth=true&logoSize=120&mode=gambling&pmListLimit=20&pollLimit=5&predefinedAmounts=200%2C500%2C1000&predefinedValues=true&preventCancelWithdrawal=false&receiptAmountDisplayStyle=symbol&receiptAmountTransactionStyle=TxAmount&receiptExcludeKeys=&saveAccountOption=false&scrollToOffset=0&scrollToPm=nearest&selectlastusedtxmethod=false&showAccounts=list-first&showAmountLimits=false&showBonusCode=false&showFee=true&showFooter=true&showHeader=true&showListHeaders=false&showReceipt=true&showTermsConditions=false&showTransactionOverview=true&singlePageFlow=false&storeAccount=true&tabs=false&zebraffeLoader=true&theme_input_color=%23222324&theme_input_fontSize=14px&theme_input_height=52px&theme_input_borderRadius=2px&theme_inputbackground_color=%23ffffff&theme_labels_color=%23424242&theme_labels_fontSize=12px&theme_headings_color=%23333&theme_headings_fontSize=14px&theme_loader_color=%2346beab&theme_error_color=%23ff2e56&theme_buttons_color=%2346beab&theme_headerbackground_color=%23ffffff&theme_background_color=%23ffffff&theme_cashierbackground_color=%23ffffff&theme_cardbackground_color=transparent&theme_border_radius=4px&theme_margin_size=14px'
    if (url) {
      const data = await getIframeUrl(url)
      return data.split('/')[4]
    }
  } catch (err) {
    console.log(err)
    return null
  }
}

export const getBootstrapVersionFromUrl = async (getIframeUrl) => {
  try {
    const url = iframeUrl()
    if (url) {
      try {
        const cashierUrl = new URL(url)
        return cashierUrl.searchParams.get('attributes.bootstrapVersion')
      } catch (error) {
        console.log('Failed to extract bootstrap version')
        return false
      }
    }
  } catch (err) {
    console.log(err)
    return null
  }
}

export const filterOldProperties = (configs) => {
  const filtered = {}
  const allConfigs = configsInfo()
  for (const prop in configs) {
    if (Object.prototype.hasOwnProperty.call(allConfigs, prop)) {
      filtered[prop] = configs[prop]
    }
  }
  return filtered
}

export const checkIfJson = (code) => {
  let isJson = typeof code === 'object'
  let formatCode = code
  try {
    const parsed = JSON.parse(code)
    isJson = typeof parsed === 'object'
    formatCode = parsed
  } catch (err) {
    console.log(err)
  }
  if (isJson) {
    for (const i in formatCode) {
      const propIsJsonFormat = code.includes(`"${i}"`)
      if (!propIsJsonFormat) {
        return false
      }
    }
  }
  return isJson
}

export const downloadFile = (filename, text) => {
  const pom = document.createElement('a')
  pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
  pom.setAttribute('download', filename)

  if (document.createEvent) {
    const event = document.createEvent('MouseEvents')
    event.initEvent('click', true, true)
    pom.dispatchEvent(event)
  } else {
    pom.click()
  }
}

export const getConfigPageVersion = async () => {
  try {
    let result = false
    const myHeaders = new Headers()
    myHeaders.append('pragma', 'no-cache')
    myHeaders.append('cache-control', 'no-cache')
    const headers = {
      method: 'GET',
      headers: myHeaders
    }
    await fetch(window.location.href, headers)
      .then(res => res.text())
      .then(html => {
        const fetchVersion = html.match(/<h3 id="config-version">(.*)<\/h3>/) || html.match(/<h3 id=config-version>(.*)<\/h3>/)
        const version = fetchVersion && fetchVersion[1]
        result = version && version > projectVersion
        if (result) {
          console.log(`Project version: ${projectVersion}`)
          console.log(`Fetched version: ${version}`)
        }
      })
    return result
  } catch (err) {
    return false
  }
}

export const getAttributesAsObject = (_attributes, _userAttributes) => {
  const returnObj = {
    attributes: {},
    user: {}
  }
  const newLineRegex = /[\n\r]/g
  const attributes = _attributes.split(newLineRegex)
  const userAttributes = _userAttributes.split(newLineRegex)
  attributes.forEach(v => {
    if (v) {
      const trimmed = v.trim()
      const val = trimmed.split('=')
      val && (returnObj.attributes[val[0]] = val[1])
    }
  })
  userAttributes.forEach(v => {
    if (v) {
      const trimmed = v.trim()
      const val = trimmed.split('=')
      val && (returnObj.user[val[0]] = val[1])
    }
  })
  return returnObj
}
